<template>
  <div>
    <van-nav-bar
      title="销售统计"
      :left-text="'您好，' + userInfo.emp_name"
    />
    <div ref="chart" style="width: 380px; height: 300px;"></div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { reportByDate } from '@/api/sell/order'
export default {
  name: 'SellReportByDate',
  data() {
    return {
      loading: false,

      chart: null,
      queryCondition: {
        begin_delivery_time: this.Utils.df(null, '2020-06-24 00:00:00'),
        end_delivery_time: this.Utils.df(null, '{y}-{m}-{d} 23:59:59')
      }
    }
  },
  computed: {
    ...mapGetters(['userInfo'])
  },
  mounted() {
    this.chart = this.echarts.init(this.$refs['chart'])
    this.query()
  },
  methods: {
    query() {
      this.data = []
      this.loading = true
      reportByDate(this.queryCondition).then(resp => {
        const rows = resp.rows || []
        this.loading = false
        if (rows.length > 0) {
          const xData = []
          const seriesData = [{
            name: '销售额',
            type: 'line',
            stack: '销售额',
            areaStyle: {
              color: '#dd6161'
            },
            data: []
          }, {
            name: '原值',
            type: 'line',
            stack: '原值',
            areaStyle: {
              color: '#13c2c2'
            },
            data: []
          }]
          rows.forEach(row => {
            if (row.delivery_time !== '合计') {
              const deliveryTime = new Date(row.delivery_time)
              xData.push(deliveryTime.getDate())
              seriesData[0].data.push((row.goods_real_amount / 10000.00).toFixed(2))
              seriesData[1].data.push((row.goods_amount / 10000.00).toFixed(2))
            }
          })
          const option = {
            title: {
              text: '近7日销售情况（万元）'
            },
            tooltip: {
              trigger: 'axis',
              axisPointer: {
                type: 'cross',
                label: {
                  backgroundColor: '#6a7985'
                }
              }
            },
            legend: {
              right: '20',
              data: ['销售额', '原值']
            },
            grid: {
              left: '3%',
              right: '4%',
              bottom: '3%',
              containLabel: true
            },
            xAxis: [
              {
                type: 'category',
                boundaryGap: false,
                data: xData
              }
            ],
            yAxis: {
              type: 'value'
            },
            series: seriesData
          }
          this.chart.setOption(option)
        }
      }).catch(error => {
        this.loading = false
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/sell/report-by-date.vue